import { Component, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ViewController } from 'ionic-angular';
import {DomSanitizer } from '@angular/platform-browser';
import { TimelineService } from '../../../../../../UI/src/app/shared/timeline/timeline.service';
@Component({
  selector: 'page-view-offer',
  templateUrl: 'view-offer-dialog.component.html'
})
export class ViewOfferDialogComponent implements  AfterViewInit {
  fileId: any;
  fileName: string;
  originalFileName: string;
  selectedFile: any;
  alertData: any;
  translations: any;
  constructor(
     private translate: TranslateService,
     public sanitizer: DomSanitizer ,
     public viewCtrl: ViewController,
     public timelineService: TimelineService
  ) {}

  ngAfterViewInit(){
    setTimeout(() => {
      let elm = <HTMLDivElement>document.querySelector('ion-modal div');
      elm.setAttribute('tabindex','-1');
      elm.setAttribute('role','dialog');
      elm.focus();
    },300)
  }

  getUrl()
  {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.timelineService.fileUrl);
  }
  getId(){return this.timelineService.offerBtnId;}
  close() {
    this.viewCtrl.dismiss();
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/timeline/view-offer/view-offer-dialog.component.ts